<template>
	<div class="user-orders-page">
		<div
			class="user-orders-content desktop-center"
			v-if="orders.length > 0 && !loadingOrders"
		>
			<UserSuborder
				v-for="order in orders"
				:key="order.sub_orders[0].id"
				:order="order"
				@toggleLoader="toggleLoader"
				@confirmClear="confirmClear"
			/>
		</div>
		<div v-else-if="!loader" class="user-orders-empty">
			<img src="/images/2k-no-orders.png" alt="No Orders" />
			<div class="user-orders-empty-title">No Past Orders Found</div>
			<div class="user-orders-empty-subtitle">
				Place an order to get started!
			</div>
			<router-link
				tag="button"
				class="button button-primary button-auto"
				:to="homePath"
				@click.native="orderNowClicked"
			>
				Order Now
			</router-link>
		</div>
		<ConfirmationModal ref="confirmationModal" />
	</div>
</template>

<style scoped>
.user-orders-page {
	background: var(--sk-grey-bg);
	overflow-y: auto;
}

.user-orders-content {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 10px 20px 0 20px;
}

.user-orders-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.user-orders-empty img {
	width: 150px;
}

.user-orders-empty-title {
	font-size: 18px;
	font-weight: 600;
	color: var(--gR-base-80);
	margin-top: 50px;
}

.user-orders-empty-subtitle {
	margin-top: 15px;
	font-size: 14px;
	color: var(--sk-grey3);
}

.user-orders-empty .button {
	padding: 15px 25px;
	font-weight: 400;
	margin-top: 50px;
}
</style>

<script>
import loaderMixin from "@/mixins/loader-mixin"
import UserSuborder from "@/components/user/UserSuborder.vue"
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue"

export default {
	name: "UserOrders",
	mixins: [loaderMixin],
	components: {
		UserSuborder,
		ConfirmationModal
	},
	data: function () {
		return {
			loadingOrders: false
		}
	},
	computed: {
		orders() {
			return this.$store.state.orders
		},
		homePath() {
			const slug = this.$store.state.business
				? this.$store.state.business.slug
				: ""
			return `/${slug}`
		}
	},
	methods: {
		orderNowClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Orders Empty CTA Clicked"
			})
		},
		confirmClear(promise) {
			this.$refs.confirmationModal
				.open({
					title: "Reorder",
					body: "Reordering will clear your Cart. Are you sure you want to continue?",
					cancel: "Keep cart",
					confirmation: "Continue"
				})
				.then((confirmed) => {
					promise.resolve(confirmed)
				})
		}
	},
	mounted: function () {
		this.toggleLoader(true)
		this.loadingOrders = true
		this.$store.dispatch("getUserOrders").finally(() => {
			this.loadingOrders = false
			this.toggleLoader(false)
		})
	}
}
</script>